import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Global scroll-to-top on route change. React Router preserves the previous
 * scroll position by default, which means navigating from a footer CTA to a
 * new page lands the user at the bottom of the new page.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}
